import styled, { css } from 'styled-components';

interface ClassifParams {
	selected: boolean;
}

export const Container = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	position: fixed;
	top: 3.5rem;
	left: 4.4rem;
	background-color: #fff;
	padding: 0 0.5rem;
	width: 100%;
	max-width: calc(100vw - 5.35rem); // 6.25rem = 100px
	// border: 2px solid blueviolet;

	// 1080px
  @media (max-width: 67.5rem) {
		max-width: calc(100vw - 5.6rem);
		top: 3.7rem;
		left: 4.6rem;
  }
	// 767px
  @media (max-width: 47.9375rem) {
    max-width: calc(100vw - 1rem); // 0.625rem = 10px
		top: 6.8rem; // top: 3.9rem;
		left: 0;
  }
	// 720px
  @media (max-width: 45rem) {
		max-width: 100%; // calc(100vw - 1.1rem);
		top: 7.2rem; // top: 3.9rem;
  }
	// 479px
  @media (max-width: 29.9375rem) {
		top: 6.7rem; // top: 3.9rem;
  }
`;

export const ButtonsScroll = styled.button`
	display: flex;
	justify-content: center;
	align-items: center;
	border: none;
	background-color: #fff;
	border-radius: 50%;
`;

export const Classifs = styled.div`
	display: flex;
	align-items: center;
	width: auto;
	max-width: 100%;
	scroll-behavior: smooth;
	margin: 0 0.5rem;
	padding: 0.3rem 0;
	overflow-x: scroll;

	::-webkit-scrollbar {
    display: none; /* Might be enough */
    background: transparent;
    visibility: hidden;
    width: 0px;
  }

	-ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
  scrollbar-width: none;
`;

export const Classif = styled.div<ClassifParams>`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0 0.8rem;
	cursor: pointer;

	span {
		display: flex;
		justify-content: center;
		align-items: center;
		white-space: nowrap;
		text-align: center;
		font-size: 0.9375rem;// 0.8rem;
		font-weight: 500;
		text-transform: uppercase;
		color: #333;
		padding: 0.3125rem 0;
	}

	${props =>
	props.selected &&
		css`
			border-bottom-width: 2px;
			border-bottom-color: #1a83ff;
			span {
				color:#1a83ff;
			}
		`}
`;
